import { render } from "./TaskDialog.vue?vue&type=template&id=08f6cf18&scoped=true"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"

import "./TaskDialog.vue?vue&type=style&index=0&id=08f6cf18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f6cf18"]])

export default __exports__